import { render, staticRenderFns } from "./BotSelect.vue?vue&type=template&id=dbe40320"
import script from "./BotSelect.vue?vue&type=script&lang=js"
export * from "./BotSelect.vue?vue&type=script&lang=js"
import style0 from "./BotSelect.vue?vue&type=style&index=0&id=dbe40320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports